import React from 'react';
import { SectionWrapper } from './shared/SectionWrapper';
export function InstructorBio() {
  return <SectionWrapper bg="cream" data-id="element-115">
      <div className="max-w-4xl mx-auto" data-id="element-116">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-warm-dark mb-12" data-id="element-117">
          ¿Quién te guía dentro de Nails Artist Expert?
        </h2>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-soft border border-blush flex flex-col md:flex-row gap-8 md:gap-12 items-center md:items-start" data-id="element-118">
          {/* Avatar */}
          <div className="w-40 h-40 md:w-56 md:h-56 shrink-0 rounded-full bg-gradient-to-br from-rose-light to-rose p-1 shadow-glow" data-id="element-119">
            <img src="https://cdn.magicpatterns.com/uploads/9JfSVkLYTdM8zZQVouSnnF/Clara-scaled-1-980x1373.jpg" alt="María Clara Casas — Instructora de Nails Artist Expert" className="w-full h-full rounded-full object-cover object-top border-4 border-white" data-id="element-120" />
          </div>

          <div className="flex-1 text-center md:text-left" data-id="element-121">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-warm-dark mb-2" data-id="element-122">
              Hola, soy María Clara Casas
            </h3>
            <p className="text-rose font-medium mb-6" data-id="element-123">
              Fundadora del Programa Profesional Nails Artist Expert
            </p>

            <div className="space-y-4 text-warm-muted leading-relaxed" data-id="element-124">
              <p data-id="element-125">
                Llevo <strong data-id="element-126">[+5] años</strong> trabajando como manicurista
                profesional y formando alumnas en toda Latinoamérica. Más de{' '}
                <strong data-id="element-127">[+500] mujeres</strong> ya pasaron por Nails Artist
                Expert y aplicaron este método en sus propios estudios y
                emprendimientos.
              </p>

              <p data-id="element-128">
                No enseño desde la teoría:{' '}
                <strong className="text-warm-dark" data-id="element-129">
                  enseño lo que aplico set tras set en mi trabajo real.
                </strong>
              </p>

              <p data-id="element-130">
                Creé esta formación para mujeres que quieren vivir de esto en
                serio, pero sobre todo para quienes <strong data-id="element-131">ya trabajan</strong>{' '}
                y se cansaron de lo mismo:
              </p>

              <ul className="list-disc list-inside text-left space-y-2 ml-2 mb-4" data-id="element-132">
                <li data-id="element-133">Sets inconsistentes que no se ven "nivel estudio"</li>
                <li data-id="element-134">Tiempos eternos que arruinan la agenda</li>
                <li data-id="element-135">
                  Esa inseguridad que aparece cuando querés{' '}
                  <strong data-id="element-136">subir precios</strong>
                </li>
              </ul>

              <p className="bg-blush p-4 rounded-xl text-warm-dark font-medium border border-rose/10" data-id="element-137">
                Acá no venís a motivarte. Venís a{' '}
                <strong data-id="element-138">subir tu estándar técnico</strong> con un método claro,
                paso a paso.
              </p>

              <p className="text-sm" data-id="element-139">
                Además, cuando entrás, recibís acompañamiento donde respondemos
                dudas mientras aplicás la técnica.
              </p>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}